import { createSelector } from "reselect";

export const patientTypeSelector = createSelector(() => {
  return "Patient";
});
